import React, { useState, useRef } from "react";
import { useContainerWidth } from "../hooks/useContainerWidth";
import { FloatingChatBubble } from "./FloatingChatBubble";
import { ExpandedChatWindow } from "./ExpandedChatWindow";

export const BubblePreviewSide = ({ colors, iconUrl, bubbleColor, companyName, chatHeaderText,isWhitelabelled }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const containerRef = useRef(null);
  const containerWidth = useContainerWidth(containerRef);
  const isMobile = containerWidth < 360;

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        background: "#f0f2f5",
        borderRadius: "12px",
        position: "relative",
        overflow: "hidden",
        border: `1px solid ${colors.border}`,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 40,
          left: 0,
          right: 0,
          bottom: 0,
          background: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          overflow: "hidden",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "12px" : "20px",
          right: isMobile ? "12px" : "20px",
          zIndex: 1000,
        }}
      >
        <FloatingChatBubble
          iconUrl={iconUrl}
          bubbleColor={bubbleColor}
          onClick={() => setIsChatOpen(!isChatOpen)}
          isChatOpen={isChatOpen}
          compact={isMobile}
          isWhitelabelled={isWhitelabelled}
        />
      </div>

      <ExpandedChatWindow
        colors={colors}
        company={companyName}
        onClose={() => setIsChatOpen(false)}
        isVisible={isChatOpen}
        chatHeaderText={chatHeaderText}
        isMobile={isMobile}
        bubbleColor={bubbleColor}
      />
    </div>
  );
};